<template>
  <div class="pack-header">
    <!-- 未购买状态 -->
    <template v-if="noBuy">
      <div class="title1">{{ headInfo.title }}</div>
      <BenefitList
        :benefitInfo="benefitInfo"
        :noBuy="noBuy"
        @handleClick="goDetailed"
        @goSettingBir="goSettingBir"
        @getBirthdayCoupons="getBirthdayCoupons"
        @goCoupons="goCoupons"
      />
      <div class="line-grey"></div>
    </template>
    <!-- 购买状态 -->
    <template v-else>
      <div class="title2">
        <div class="title2-icon"><img :src="headInfo.iconUrl" alt="" /></div>
        <div class="title2-info">
          <div class="title2-info_main">{{ headInfo.title }}</div>
          <div
            class="title2-info-time"
            :class="{ 'title2-info-time1': isBuyAndNoSubscriptionStatus }"
            v-if="headInfo.validDateDesc"
          >
            {{ headInfo.validDateDesc }}
          </div>
        </div>
      </div>
      <div class="save-price" v-if="hasAlreadySavedDisplay">
        <div class="left-text">{{ alreadySavedDisplay.text }}</div>
        <div class="right-text">{{ alreadySavedDisplay.amount }}</div>
      </div>
      <div class="line-grey"></div>
      <BenefitList
        :benefitInfo="benefitInfo"
        :noBuy="noBuy"
        @handleClick="goDetailed"
        @goSettingBir="goSettingBir"
        @getBirthdayCoupons="getBirthdayCoupons"
        @goCoupons="goCoupons"
      />
      <div class="line-grey"></div>
    </template>
  </div>
</template>
<script>
import { isEmpty } from "lodash-es";
import BenefitList from "../benefitList/index.vue";
export default {
  props: [
    "headInfo",
    "benefitInfo",
    "noBuy",
    "isBuyAndNoSubscriptionStatus",
    "alreadySavedDisplay",
  ],
  components: {
    BenefitList,
  },
  computed: {
    hasAlreadySavedDisplay() {
      return !isEmpty(this.alreadySavedDisplay);
    },
  },
  methods: {
    // 详情弹窗
    goDetailed(data) {
      this.$emit("goDetailed", data);
    },
    // 设置生日
    goSettingBir() {
      this.$emit("goSettingBir");
    },
    // 领取生日券
    getBirthdayCoupons() {
      this.$emit("getBirthdayCoupons");
    },
    // 跳转到优惠券中心
    goCoupons() {
      this.$emit("goCoupons");
    },
  },
};
</script>

<style lang="scss" scoped>
.pack-header {
  .title1 {
    padding-top: 36px;
    padding-left: 32px;
    padding-right: 32px;
    font-family: DiDiSans-Pro-Bold;
    font-size: 64px;
    color: #000000;
    line-height: 68px;
    margin-bottom: 48px;
    // word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* 这里是超出几行省略 */
    overflow: hidden;
  }

  .line-grey {
    height: 12px;
    background: #f7f7f7;
  }

  .title2 {
    display: flex;
    align-items: center;
    padding-top: 36px;
    margin-bottom: 48px;
    padding-left: 32px;
    padding-right: 32px;

    .title2-icon {
      width: 84px;
      height: 84px;
      margin-right: 16px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .title2-info {
      flex: 1;

      .title2-info_main {
        font-family: DiDiSans-Pro-Bold;
        font-size: 64px;
        color: #000000;
        line-height: 64px;
        margin-bottom: 8px;
        // word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        /* 这里是超出几行省略 */
        overflow: hidden;
      }

      .title2-info-time {
        opacity: 0.6;
        font-family: DiDiSans-Pro-Regular;
        font-size: 24px;
        color: #000000;
        line-height: 24px;
        // word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        /* 这里是超出几行省略 */
        overflow: hidden;
      }

      .title2-info-time1 {
        color: #ff4060;
        font-family: DiDiSans-Pro-Medium;
        opacity: 1;
      }
    }
  }

  .save-price {
    margin: 0 auto 48px;
    background: url("../../../../assets/images/member/save_bg.png") no-repeat;
    background-size: 100% 100%;
    height: 100px;
    width: 686px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left-text {
      margin-left: 32px;
      font-family: DiDiSans-Pro-Medium;
      font-size: 28px;
      color: #000000;
      line-height: 32px;
    }

    .right-text {
      font-family: DiDiSans-Pro-Bold;
      font-size: 40px;
      color: #ff8040;
      line-height: 44px;
      margin-right: 30px;
    }
  }
}
</style>
